import { CSSProperties } from "react";

import { Column } from "@/components/Column";

import { playyardSky } from "@/lib/playyardSky";

const WISP_COUNT = 14;

// Ghost lights that stand in for fireflies: bigger, cooler, and hugging the
// grass instead of floating up into the sky.
const WISPS = Array.from({ length: WISP_COUNT }, (_, index) => ({
  left: 3 + playyardSky.random(index + 1401) * 94,
  top: 62 + playyardSky.random(index + 1501) * 32,
  durationS: 4 + playyardSky.random(index + 1601) * 4,
  delayS: -playyardSky.random(index + 1701) * 8,
  driftX: (playyardSky.random(index + 1801) - 0.5) * 10,
  driftY: (playyardSky.random(index + 1901) - 0.5) * 4,
}));

export const PlayyardWisps = () => {
  return (
    <Column className="pointer-events-none absolute inset-0 z-[42]">
      {WISPS.map((wisp, index) => (
        <Column
          key={index}
          className="staffer-pet-yard-firefly absolute h-[9px] w-[9px] rounded-full bg-[#d6fff4] shadow-[0_0_14px_6px_rgb(120_255_220_/_0.55)] blur-[1px]"
          style={
            {
              left: `${wisp.left.toString()}%`,
              top: `${wisp.top.toString()}%`,
              animationDelay: `${wisp.delayS.toString()}s`,
              "--yard-firefly-duration": `${wisp.durationS.toString()}s`,
              "--yard-firefly-x": `${wisp.driftX.toString()}cqw`,
              "--yard-firefly-y": `${wisp.driftY.toString()}cqw`,
            } as CSSProperties
          }
        />
      ))}
    </Column>
  );
};
